"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const moment_1 = __importDefault(require("moment"));
const react_router_dom_1 = require("react-router-dom");
const constants_1 = require("../assets/constants/constants");
const strings_1 = require("../assets/strings/strings");
const data_repository_1 = require("../dataSource/data_repository");
const CheckinService_1 = __importDefault(require("../services/CheckinService"));
const format_1 = require("../utils/format");
const message_utils_1 = __importDefault(require("../utils/message_utils"));
const users_1 = require("../utils/users");
const RoutesPaths_1 = require("../routes/RoutesPaths");
const response_codes_1 = require("../assets/constants/response_codes");
function useQuery() {
    return new URLSearchParams((0, react_router_dom_1.useLocation)().search);
}
const useCheckinData = () => {
    const [fetchedData, setFetchedData] = (0, react_1.useState)({});
    const [loadedData, setLoadedData] = (0, react_1.useState)(false);
    const query = useQuery();
    const [queryObj, setQueryObj] = (0, react_1.useState)({});
    const location = (0, react_router_dom_1.useLocation)();
    const history = (0, react_router_dom_1.useHistory)();
    const parseVehicles = (custom2, custom9) => {
        let parsedVehicle = {
            model: '',
            plate: '',
            usedFrom: '',
            usedTo: '',
        };
        if (custom9) {
            const parsedCustom9 = JSON.parse(custom9);
            if (parsedCustom9 === null || parsedCustom9 === void 0 ? void 0 : parsedCustom9.vehicles) {
                return parsedCustom9 === null || parsedCustom9 === void 0 ? void 0 : parsedCustom9.vehicles[0];
            }
            if (custom2) {
                try {
                    parsedVehicle = JSON.parse(custom2);
                }
                catch (error) {
                    const [brandColor, plate, usedFrom, usedTo] = custom2.split('|');
                    parsedVehicle = {
                        model: brandColor,
                        plate,
                        usedFrom,
                        usedTo,
                    };
                }
            }
        }
        return parsedVehicle;
    };
    const fetchRequest = (0, react_1.useCallback)(() => {
        var _a;
        CheckinService_1.default.loadCheckinData({ bookId: ((_a = queryObj.bookId) === null || _a === void 0 ? void 0 : _a.toString()) || '', propertyId: queryObj.propId || '' })
            .then(({ booking }) => __awaiter(void 0, void 0, void 0, function* () {
            var _b;
            const price = +booking.price;
            const room = yield (0, data_repository_1.getRoom)(booking.roomId);
            const totalGuests = booking.numAdult + booking.numChild;
            const reserveData = {
                firstNight: booking.firstNight,
                lastNight: (0, moment_1.default)(booking.lastNight).add(1, 'day').toString(),
                suitePrice: (0, format_1.getFormattedDouble)(price - +constants_1.DEFAULT_CLEANING_FEE),
                cleaningFee: parseFloat((0, format_1.getFormattedDouble)(constants_1.DEFAULT_CLEANING_FEE)),
                dailyQtyString: ((0, moment_1.default)(booking.firstNight).diff((0, moment_1.default)(booking.lastNight), 'days') + 1).toString(),
                guestsQtyString: totalGuests.toString(),
                totalDecimal: '',
                totalNumber: (0, format_1.getFormattedDouble)(booking.price),
                suite: {
                    suiteTitle: (_b = room === null || room === void 0 ? void 0 : room.room) === null || _b === void 0 ? void 0 : _b.name,
                },
                price: 0,
                totalPrice: booking.price,
                parkingIncluded: !!room.room.features.find((feature) => feature.feature === constants_1.PARKING_FEATURE),
                checkinData: queryObj.bookId,
                propId: queryObj.propId,
                infoPreCheckIn: booking.custom9,
                vehicles: [parseVehicles(booking.custom2, booking.custom9)],
                guest2Annotations: booking.custom5 || booking.custom6 || '',
                refererEditable: booking.refererEditable,
            };
            setFetchedData(reserveData);
            setLoadedData(true);
        }))
            .catch(err => {
            const { status } = err.response;
            if (status === response_codes_1.HTTPCodes.INVALID_ACCESS_TOKEN_ERROR_CODE) {
                (0, users_1.removeUserFromStorage)();
                const lastUrl = location.pathname + location.search;
                (0, users_1.setLastPageBeforeLogin)(lastUrl);
                history.push(RoutesPaths_1.routesPaths.login);
            }
            else {
                message_utils_1.default.error({
                    message: strings_1.BookingMessages.messageCannotRetrieveData,
                });
            }
        });
    }, [queryObj.bookId, queryObj.propId, history, location.pathname, location.search]);
    (0, react_1.useEffect)(() => {
        const bookId = query.get('bookId');
        const propId = query.get('propId');
        if (bookId && propId) {
            setQueryObj({ bookId, propId });
        }
    }, []);
    (0, react_1.useEffect)(() => {
        if (queryObj.bookId && queryObj.propId)
            fetchRequest();
    }, [fetchRequest, queryObj]);
    return [fetchedData, loadedData];
};
exports.default = useCheckinData;
